export default function Masters(){

return(

<div className="mobile-app">

<div className="page-header">
<h2>Masters</h2>
</div>

</div>

)

}